"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GraphicsSubComponents = void 0;
const rc_js_util_1 = require("rc-js-util");
/**
 * @public
 * {@inheritDoc IGraphicsSubComponents}
 */
class GraphicsSubComponents {
    constructor(graphicsComponents) {
        this.graphicsComponents = graphicsComponents;
    }
    addComponent(graphicsComp) {
        this.graphicsComponents.push(graphicsComp);
    }
    getSubComponents() {
        return this.graphicsComponents;
    }
    setSubComponent(graphicsComp, index) {
        DEBUG_MODE && rc_js_util_1._Debug.assert(this.graphicsComponents.length > index, "index OOB");
        this.graphicsComponents[index] = graphicsComp;
    }
}
exports.GraphicsSubComponents = GraphicsSubComponents;
//# sourceMappingURL=graphics-sub-components.js.map